import React from 'react';
import { Card, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../../estilos/gescomaux.css';

export interface OpcionCard {
  key: string;
  label: string;
  icon?: React.ReactNode;
}

interface FunctionalityCardProps {
  title: string;
  icon: React.ReactNode;
  /** Ruta a la que navega la tarjeta. Si hay `opciones`, no se usa: la tarjeta abre el menú. */
  path?: string;
  description?: string;
  /** Segundo nivel (sección «Clientes»): al pulsar la tarjeta se abre un menú contextual con estas opciones. */
  opciones?: OpcionCard[];
}

/** Tarjeta de módulo del inicio: icono en una tinta y nombre en Roboto (los módulos no tienen isotipo propio, R-04). */
const FunctionalityCard: React.FC<FunctionalityCardProps> = ({
  title,
  icon,
  path,
  description,
  opciones,
}) => {
  const navigate = useNavigate();

  const tarjeta = (
    <Card
      hoverable
      className="gc-modulo"
      onClick={opciones ? undefined : () => path && navigate(path)}
      aria-haspopup={opciones ? 'menu' : undefined}
    >
      <div className="gc-modulo__icono" aria-hidden="true">{icon}</div>
      <div className="gc-modulo__nombre">{title}</div>
      {description && <div className="gc-modulo__desc">{description}</div>}
    </Card>
  );

  if (!opciones) return tarjeta;

  const items: MenuProps['items'] = opciones.map((o) => ({ key: o.key, label: o.label, icon: o.icon }));
  return (
    <Dropdown
      menu={{ items, onClick: ({ key }) => navigate(key) }}
      trigger={['click']}
      placement="bottom"
    >
      {tarjeta}
    </Dropdown>
  );
};

export default FunctionalityCard;
